import { render, staticRenderFns } from "./KpiCards.vue?vue&type=template&id=721f0b8a"
import script from "./KpiCards.vue?vue&type=script&lang=js"
export * from "./KpiCards.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports